// React
import React from "react";
//-- Notifier interface -------------------------------------------------------------------------------------------------------------------------------
export class INotifier {
    notifyInfo(title, message) { }
    notifyWarning(title, message) { }
    notifyError(title, message, autoDismiss) { }
    notifySuccess(title, message) { }
    notifyNewVersionWarning(title, message) { }
}
//-- Notifier -------------------------------------------------------------------------------------------------------------------------------
class Notifier extends INotifier {
    constructor() {
        super();
    }
    setup(notificationSystem) {
        this._notificationSystem = notificationSystem;
    }
    notifyInfo(title, message) {
        if (this._notificationSystem) {
            this._notificationSystem.addNotification({
                title,
                message,
                level: 'info',
                autoDismiss: 5,
                position: "tc",
                children: (React.createElement("div", { className: "glyphicon glyphicon-info-sign notification-icon" }))
            });
        }
    }
    notifyWarning(title, message) {
        if (this._notificationSystem) {
            this._notificationSystem.addNotification({
                title,
                message,
                level: 'warning',
                autoDismiss: 5,
                position: "tc",
                children: (React.createElement("div", { className: "glyphicon glyphicon-exclamation-sign notification-icon" }))
            });
        }
    }
    notifyError(title, message, autoDismiss = 5) {
        if (this._notificationSystem) {
            this._notificationSystem.addNotification({
                title,
                message,
                level: 'error',
                autoDismiss,
                position: "tc",
                children: (React.createElement("div", { className: "glyphicon glyphicon-exclamation-sign notification-icon" }))
            });
        }
    }
    notifySuccess(title, message) {
        if (this._notificationSystem) {
            this._notificationSystem.addNotification({
                title,
                message,
                level: 'success',
                autoDismiss: 5,
                position: "tc",
                children: (React.createElement("div", { className: "glyphicon glyphicon glyphicon-ok-sign notification-icon" }))
            });
        }
    }
    notifyNewVersionWarning(title, message) {
        if (this._notificationSystem) {
            this._notificationSystem.addNotification({
                title: title,
                message: message,
                level: 'info',
                position: "tc",
                autoDismiss: appVersionCheckIntervalInMillis / 1000,
                dismissible: false,
                action: {
                    label: "Refresh!",
                    callback: () => location.href = location.href
                }
            });
        }
    }
}
//-- Singleton Notifier exposed to the rest of the app -------------------------------------------------------------------------------------------------------------------------------
export var notifier = new Notifier();
export const initialiseNotifier = (notificationSystem) => {
    const notify = notifier;
    notify.setup(notificationSystem);
};
